export default {
  s: '%d秒',
  smicro: '%d秒',
  smid: '%d秒',

  ss: '%d秒',
  ssmicro: '%d秒',
  ssmid: '%d秒',

  m: '%d分钟',
  mmicro: '%d分钟',
  mmid: '%d分钟',

  mm: '%d分钟',
  mmmicro: '%d分钟',
  mmmid: '%d分钟',

  h: '%d小时',
  hmicro: '%d小时',
  hmid: '%d小时',

  hh: '%d小时',
  hhmicro: '%d小时',
  hhmid: '%d小时',

  d: '%d天',
  dmicro: '%d天',
  dmid: '%d天',

  dd: '%d天',
  ddmicro: '%d天',
  ddmid: '%d天',
};
